var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ColFilterModalContainer, DataContainer } from './ColumnsFilterModal.style';
import { Icon } from '../Icon';
import { Button } from '../Button/Button.style';
import { CheckboxGroup } from '../Checkbox/Checkbox.style';
import close from '../../images/close.svg';
import onClickOutside from 'react-onclickoutside';
var ColumnsFilterModal = /** @class */ (function (_super) {
    __extends(ColumnsFilterModal, _super);
    function ColumnsFilterModal(props) {
        var _this = _super.call(this, props) || this;
        /* Funkcja wykonywana przy każdej zmianie pola wyboru */
        _this.gatherSelectedFilter = function (name, selectedColumns) {
            /* Aktualizuje zaznaczone elementu w stanie komponentu */
            _this.setState(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = selectedColumns, _a)));
            });
        };
        /* Funkcja wykonywana po naciśnięciu przycisku Confirm (Zatwierdź) */
        _this.confirm = function () {
            /* Zbiera zaznaczone pola w jeden obiekt, z podziałem na filtry kolumn głównych i szczegółów */
            var selectedFilters = {
                columns: _this.state.main,
                details: _this.state.details,
            };
            /* jeśli nie wybrano żadnej nowej wartości...  */
            if (selectedFilters.columns.sort().toString() === _this.props.selectedMainColumns.sort().toString() &&
                selectedFilters.details.sort().toString() === _this.props.selectedDetailColumns.sort().toString()) {
                /* ...zamyka modal nie wykonuje żadnej dodatkowej akcji */
                _this.props.onClose();
            }
            else if (selectedFilters.columns.length > 0 && selectedFilters.details.length > 0) {
                /* jeśli wybrana jest minimum jedna kolumna z każdego zestawu...  */
                /* ...wysyła obiekt z listą zaznaczonych filtrów... */
                _this.props.onFilterConfirmation(selectedFilters);
                /* ... oraz zamyka modal */
                _this.props.onClose();
                /* w przeciwnym wypadku wykonuje callback onError oraz resetuje dotychczasowe zaznaczenie danych */
            }
            else {
                _this.props.onError();
                _this.reset();
            }
        };
        /* Funkcja resetująca dotychczasowe zaznaczenie pól wyboru */
        _this.reset = function () {
            _this.updateStateFromProps();
        };
        /* Sterownik dla paczki react-onclickoutside */
        _this.handleClickOutside = function () {
            _this.closeModal();
        };
        /* Funkcja zamknięcia modala - łączy akcję zamknięcia z resetem zaznaczonych danych */
        _this.closeModal = function () {
            _this.reset();
            _this.props.onClose();
        };
        _this.state = {
            main: [],
            details: [],
        };
        return _this;
    }
    ColumnsFilterModal.prototype.componentDidMount = function () {
        this.updateStateFromProps();
    };
    ColumnsFilterModal.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.selectedMainColumns !== this.props.selectedMainColumns ||
            prevProps.selectedDetailColumns !== this.props.selectedDetailColumns) {
            this.updateStateFromProps();
        }
    };
    /* Funkcja aktualizująca stan komponentu do wartości dostarczonych z propsów */
    ColumnsFilterModal.prototype.updateStateFromProps = function () {
        var _this = this;
        this.setState(function (prev) { return (__assign(__assign({}, prev), { main: _this.props.selectedMainColumns, details: _this.props.selectedDetailColumns })); });
    };
    ColumnsFilterModal.prototype.render = function () {
        var _a = this.props, mainColumns = _a.mainColumns, detailsColumns = _a.detailsColumns, opened = _a.opened, translations = _a.translations;
        var _b = this, gatherSelectedFilter = _b.gatherSelectedFilter, reset = _b.reset, confirm = _b.confirm;
        return (React.createElement(ColFilterModalContainer, { opened: opened },
            React.createElement(Icon, { className: 'icon icon_column_modal_close', path: close, onClick: this.closeModal, dataCy: 'btnModalColumnsFilterClose' }),
            React.createElement(DataContainer, { detailsOnly: this.props.detailsOnly, "data-cy": 'modalColumnsFilterContainer' },
                React.createElement("div", { "data-cy": 'modalColumnsFilterMainData' },
                    React.createElement("h4", null, translations.mainFilterTitle),
                    "Columns",
                    React.createElement("h5", null, translations.mainSubTitle),
                    React.createElement(CheckboxGroup, { value: this.state.main, options: mainColumns, onChange: gatherSelectedFilter.bind(null, 'main') })),
                this.props.detailsOnly ? null : (React.createElement("div", { "data-cy": 'modalColumnsFilterDetailsData' },
                    React.createElement("h4", null, translations.detailsTitle),
                    React.createElement("h5", null, translations.subDetailsTitle),
                    React.createElement(CheckboxGroup, { value: this.state.details, options: detailsColumns, onChange: gatherSelectedFilter.bind(null, 'details') })))),
            React.createElement("div", null,
                React.createElement(Button, { onClick: this.closeModal, outlined: true, "data-cy": 'btnModalColumnsFilterCancel' }, translations.cancel),
                React.createElement(Button, { onClick: confirm, "data-cy": 'btnModalColumnsFilterConfirm' }, translations.confirm))));
    };
    return ColumnsFilterModal;
}(React.Component));
export { ColumnsFilterModal };
export var ColFilterModalWithHandler = onClickOutside(ColumnsFilterModal);
